module.exports = __webpack_public_path__ + "floppy-disk.66fb91a0f884b15cd3143d72e3289ddc.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/floppy-disk.svg
// module id = 1658
// module chunks = 39